export enum Attribute {
  Age = 'Age',
  Gender = 'Gender',
  LSOA = 'LSOA',
  HasTeam = 'HasTeam',
  TeamName = 'TeamName',
  TeamType = 'TeamType',
  IsTeamLeader = 'IsTeamLeader',
  HasCard = 'HasCard',
  HasApp = 'HasApp',
  GameId = 'GameId',
  HasFamilyGroup = 'HasFamilyGroup',
  IsFamilyManager = 'IsFamilyManager',
}

export type Attributes = Partial<Record<Attribute, (string | number)[]>>

export interface EndpointUpdate {
  optOut: 'NONE'
  address: string
  channelType: 'CUSTOM'
  attributes?: Attributes
  userAttributes?: Attributes
  metrics?: Attributes
}
